import { CheckCircleIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import React from 'react';

const TabButton = ({ selected, children }) => {
  return (
    <div
      className={clsx(
        'bg-white relative rounded-lg shadow-sm px-2 py-1.5 font-medium cursor-pointer flex w-full h-full items-start text-gray-800 text-left overflow-hidden',
        {
          'border border-chocolate-600 ring-1 ring-chocolate-600': selected,
          'hover:bg-gray-50 border border-gray-200 ring-1 ring-transparent': !selected,
        },
      )}
    >
      {children}

      <CheckCircleIcon
        className={clsx(
          !selected ? 'invisible' : '',
          'h-5 w-5 ml-auto flex-shrink-0 absolute right-2 top-2 fill-white stroke-chocolate-600',
        )}
        aria-hidden="true"
      />
    </div>
  );
};

export default TabButton;
